
import { hermioneBio, dumbledoreBio, ronBio } from './harryBios'
import { hermioneReviewerReviewHinge, dumbledoreReviewerReviewBumble, ronReviewerReviewTinder } from './harryReviewerReviews'

export const hermioneReviewerProfile = {
  _id: 'hermioneReviewerProfileId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-4-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...hermioneBio },
  profileReviews: [
    // { ...hermioneProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...hermioneReviewerReviewHinge }
  ],
}

export const dumbledoreReviewerProfile = {
  _id: 'dumbledoreReviewerProfileId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-9-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...dumbledoreBio },
  profileReviews: [
    // { ...dumbledoreProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...dumbledoreReviewerReviewBumble }
  ],
}

export const ronReviewerProfile = {
  _id: 'ronReviewerProfileId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...ronBio },
  profileReviews: [
    // { ...ronProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...ronReviewerReviewTinder }
  ],
}